<nz-tag [nzColor]="backgroundColor"
        [ngStyle]="{'border-color': borderColor, 'background-color': selected ? selectedBgColor : backgroundColor}"
        nzMode="checkable"
        [nzChecked]="true"
        [nzBordered]="true"
        (nzCheckedChange)="onTagChecked($event)"
>
  <span [ngStyle]="{'color': selected ? selectedTextColor : textColor}">{{ label }}</span>
</nz-tag>
